import PropTypes from 'prop-types';
import React from 'react';


export default function Breadcrumb({ baseClassName, breadcrumbInfo }) {
  return (
    <div className={ `breadcrumb ${baseClassName}` }>
      { breadcrumbInfo.map((breadcrumbItem, i, arr) => (
        <span key={ i } className="breadcrumb__item">
          { (i + 1) !== breadcrumbInfo.length
            ? (
              <a
                className="breadcrumb__item__link"
                href={ breadcrumbItem.url.endsWith('/') ? breadcrumbItem.url : `${breadcrumbItem.url}/` }
              >
                { breadcrumbItem.text }
              </a>
            )
            : (
              <span key={ i } className="breadcrumb__item__link">
                { breadcrumbItem.text }
              </span>
            )
          }
          { i + 1 !== arr.length && <span className="breadcrumb__item__arrow hundredicons-arrow-right-filled" /> }
        </span>
      ))
      }
    </div>
  );
}

Breadcrumb.defaultProps = {
  baseClassName: '',
};

Breadcrumb.propTypes = {
  baseClassName: PropTypes.string,
  breadcrumbInfo: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
};
